var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PIXI from "pixi.js";
import { TextDeformer } from "./TextDeformer";
import { DEFORMER_MANIP_ENUM } from "../enums";
var red = 16711680;
var green = 65280;
var blue = 255;
var TextColorDeformer = /** @class */ (function (_super) {
    __extends(TextColorDeformer, _super);
    function TextColorDeformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deformerType = [DEFORMER_MANIP_ENUM.COLOR];
        _this._colors = [red, green, blue];
        _this._colorIndices = [0];
        return _this;
    }
    TextColorDeformer.prototype._uniforms = function () {
        return {
            uColors: this.colorsAsVec3,
            uColorIndices: this.colorIndices,
        };
    };
    Object.defineProperty(TextColorDeformer.prototype, "colors", {
        get: function () {
            return this._colors;
        },
        set: function (value) {
            // TODO: we should probably check if the length matches the indices
            //  we use in the colorIndices array
            this._colors = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextColorDeformer.prototype, "colorsAsVec3", {
        get: function () {
            return this._colors.flatMap(function (color) { return PIXI.utils.hex2rgb(color); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextColorDeformer.prototype, "colorIndices", {
        get: function () {
            return this._colorIndices;
        },
        set: function (value) {
            this._validateData(value, 1);
            this._colorIndices = value;
        },
        enumerable: false,
        configurable: true
    });
    TextColorDeformer.prototype._vertexHeader = function () {
        var colorCount = this.colors.length;
        // this is based on the selected transform type
        // we need a color per transform element (glyph, word, line, etc)
        // which is animatable
        var colorIndexCount = this.colorIndices.length;
        return "\n        attribute float aWeight;\n        uniform vec3 uColors[".concat(colorCount, "];\n        uniform float uColorIndices[").concat(colorIndexCount, "];\n        varying vec3 vColor;");
    };
    TextColorDeformer.prototype._vertexMain = function () {
        return "\n        int colorTransformIndex = int(aWeight);\n        int colorIndex = int(uColorIndices[colorTransformIndex]);\n        vColor = uColors[colorIndex];\n        ";
    };
    TextColorDeformer.prototype._fragmentHeader = function () {
        return "\n        varying vec3 vColor;\n        ";
    };
    TextColorDeformer.prototype._fragBody = function () {
        return "\n        vec4 getColor".concat(this.index, "(vec4 inputColor) {\n            return vec4(vColor, 1.0);\n        }\n        ");
    };
    return TextColorDeformer;
}(TextDeformer));
export { TextColorDeformer };
